import isSingleRowItem from './isSingleRowItem';

const createGalleryRows = (assets) => {
  const rows = []
  const columnMax = 2
  let row = []
  assets?.forEach((asset, index) => {
    if (isSingleRowItem(asset)) {
      if (row.length > 0) {
        rows.push(row)
      }
      rows.push([asset])
      row = []
    } else {
      row.push(asset)
    }

    if (row.length === columnMax || index === assets.length - 1) {
      rows.push(row)
      row = []
    }
  })

  return rows;
}

export default createGalleryRows;
